(function () {
    'use strict';

    angular.module('core')
        .controller('LoginController', ['$scope', '$location', 'userService', loginController]);

    function loginController($scope, $location, userService) {

        var search = $location.search();
        if (search) {
            $scope.noRights = search.info === 'no-rights';
            $scope.logoutInfo = search.info === 'logout';
        }

        $scope.login = function () {
            userService.login();
        };

        $scope.logout = function () {
            userService.logout();
        };
    }
})();
